<template>
  <el-container class="bg-white flex h-[100dvh] min-h-0 flex-col">
    <el-header class="shadow-md" style="padding: 10px 6px; height: 52px;">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center">
          <!-- Dashboard: 没有二级菜单 -->
          <el-button
            class="w-36"
            type="primary"
            :style="{ 
              backgroundColor: defaultActive !== ROUTES.DASHBOARD ? '#c2dbf0' : '',
              color: defaultActive !== ROUTES.DASHBOARD ? '#333333' : ''
            }"
            :text="defaultActive !== ROUTES.DASHBOARD"
            :bg="defaultActive !== ROUTES.DASHBOARD"
            @click="goToPath(ROUTES.DASHBOARD)">
            <el-icon><HomeFilled /></el-icon>
            <span>ダッシュボード</span>
          </el-button>

          <!-- 在库确认: 有二级菜单 -->
          <el-dropdown class="ml-2">
            <el-button
              class="w-8 md:w-32"
              type="info"
              :color="inventoryPaths.includes(defaultActive) ? '#000000' : ''"
              :style="{ 
                backgroundColor: !inventoryPaths.includes(defaultActive) ? '#b7b7b7' : '',
                color: !inventoryPaths.includes(defaultActive) ? '#333333' : ''
              }"
              :text="!inventoryPaths.includes(defaultActive)"
              :bg="!inventoryPaths.includes(defaultActive)">
              <el-icon><Box /></el-icon>
              <span class="hidden md:block">申請管理</span>
              <el-icon class="el-icon--right hidden md:block"><ArrowDown /></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <!-- 在庫確認：系统管理员 (因为 即将删除，暂时维持入口) -->
                <!-- <el-dropdown-item v-if="currentUserRole === ROLE_VALUES.SYSTEM " @click="goToPath(ROUTES.INVENTORY)">在庫確認</el-dropdown-item> -->
                <el-dropdown-item v-if="currentUserRole !== ROLE_VALUES.SPD" @click="goToPath(ROUTES.USAGE_CONFIRMATION)">申請登録</el-dropdown-item>
                <el-dropdown-item v-if="currentUserRole !== ROLE_VALUES.SPD" @click="goToPath(ROUTES.DECREASE_DELETE_REQUEST)">減少・削除申請</el-dropdown-item>
                <el-dropdown-item v-if="currentUserRole !== ROLE_VALUES.SPD" @click="goToPath(ROUTES.INVENTORY_HISTORY)">申請履歴</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.ARRIVAL_STATUS)">入庫状況</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <!-- 需要申請関連: 有二级菜单 -->
          <el-dropdown class="ml-2 hidden md:block" v-if="currentUserRole === ROLE_VALUES.SYSTEM || currentUserRole === ROLE_VALUES.MANAGER">
            <el-button
              class="w-8 md:w-32"
              type="info"
              :color="requestSheetPaths.includes(defaultActive) ? '#000000' : ''"
              :style="{ 
                backgroundColor: !requestSheetPaths.includes(defaultActive) ? '#b7b7b7' : '',
                color: !requestSheetPaths.includes(defaultActive) ? '#333333' : ''
              }"
              :text="!requestSheetPaths.includes(defaultActive)"
              :bg="!requestSheetPaths.includes(defaultActive)">
              <el-icon><Edit /></el-icon>
              <span class="hidden md:block">申請書管理</span>
              <el-icon class="el-icon--right hidden md:block"><ArrowDown /></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <!-- 定数master判断业务（発注確認・不足確認）入口暂时注释 -->
                <!-- <el-dropdown-item @click="goToPath(ROUTES.REQUEST_REGISTER)">発注確認（不足確認）</el-dropdown-item> -->
                <el-dropdown-item @click="goToPath(ROUTES.REQUEST_REGISTER_CONSUMPTION)">申請一覧</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.DECREASE_DELETE_REQUEST_LIST)">減少・削除申請一覧</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.REQUEST_LIST)">発注確認</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.ORDER_CONFIRM_IN)">入庫確認</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <!-- 发注书相关: 有二级菜单 -->
          <el-dropdown class="ml-2 hidden md:block" v-if="currentUserRole === ROLE_VALUES.SYSTEM || currentUserRole === ROLE_VALUES.SPD">
            <el-button
              class="w-8 md:w-28  "
              type="info"
              :color="orderSheetPaths.includes(defaultActive) ? '#000000' : ''"
              :style="{ 
                backgroundColor: !orderSheetPaths.includes(defaultActive) ? '#b7b7b7' : '',
                color: !orderSheetPaths.includes(defaultActive) ? '#333333' : ''
              }"
              :text="!orderSheetPaths.includes(defaultActive)"
              :bg="!orderSheetPaths.includes(defaultActive)">
              <el-icon><Document /></el-icon>
              <span class="hidden md:block">受注管理</span>
              <el-icon class="el-icon--right hidden md:block"><ArrowDown /></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="goToPath(ROUTES.REQUEST_LIST_SPD)">申請書一覧</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.ORDER_REGISTER_OUT)">発注表作成</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <!-- 设定: 有二级菜单（所有master表）；SPD 仅可见メッセージマスタ -->
          <el-dropdown v-if="showSettingsMenu" class="ml-2 hidden md:block">
            <el-button
              class="w-8 md:w-28"
              type="info"
              :color="settingPaths.includes(defaultActive) ? '#000000' : ''"
              :style="{ 
                backgroundColor: !settingPaths.includes(defaultActive) ? '#b7b7b7' : '',
                color: !settingPaths.includes(defaultActive) ? '#333333' : ''
              }"
              :text="!settingPaths.includes(defaultActive)"
              :bg="!settingPaths.includes(defaultActive)">
              <el-icon><Setting /></el-icon>
              <span class="hidden md:block">設定</span>
              <el-icon class="el-icon--right hidden md:block"><ArrowDown /></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="goToPath(ROUTES.DEPARTMENT)" v-if="currentUserRole === ROLE_VALUES.SYSTEM || currentUserRole === ROLE_VALUES.MANAGER">署マスタ</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.ITEM)" v-if="currentUserRole === ROLE_VALUES.SYSTEM || currentUserRole === ROLE_VALUES.SPD || currentUserRole === ROLE_VALUES.MANAGER">商品マスタ</el-dropdown-item>
                <!-- 定数设定（定数マスタ）入口暂时注释
                <el-dropdown-item @click="goToPath(ROUTES.CONSTANT)" v-if="currentUserRole === ROLE_VALUES.SYSTEM || currentUserRole === ROLE_VALUES.MANAGER">定数マスタ</el-dropdown-item>
                -->
                <el-dropdown-item @click="goToPath(ROUTES.USAGE_LIMIT)" v-if="currentUserRole === ROLE_VALUES.SYSTEM || currentUserRole === ROLE_VALUES.MANAGER">申請可能数マスタ</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.USER)" v-if="currentUserRole === ROLE_VALUES.SYSTEM ">ユーザーマスタ</el-dropdown-item>
                <el-dropdown-item @click="goToPath(ROUTES.MESSAGE)" v-if="currentUserRole === ROLE_VALUES.SYSTEM || currentUserRole === ROLE_VALUES.SPD">メッセージマスタ</el-dropdown-item>
                <el-dropdown-item v-if="canBudgetAdjustment" @click="goToPath(ROUTES.BUDGET_ADJUSTMENT)">予算調整</el-dropdown-item>
                <!-- <el-dropdown-item @click="goToPath(ROUTES.ENV_SETTINGS)" v-if="currentUserRole === ROLE_VALUES.SYSTEM">環境設定</el-dropdown-item> -->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>

        <div class="flex items-center">
          <span class="mr-3">{{ loginUserName }}</span>
          <el-dropdown>
            <el-button
              class="w-10 h-10 p-0"
              type="info"
              circle
              style="min-width: 40px; width: 40px; height: 40px; padding: 0; border-radius: 50%;">
              <el-icon class="text-xl"><User /></el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleChangePassword">パスワード変更</el-dropdown-item>
                <el-dropdown-item @click="handleLogout">ログアウト</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </el-header>

    <el-main class="min-h-0 flex-1 overflow-x-hidden overflow-y-auto" style="padding: 0;">
      <router-view />
    </el-main>

    <!-- パスワード変更ダイアログ -->
    <el-dialog
      v-model="passwordDialogVisible"
      title="パスワード変更"
      width="400px"
      align-center
      @close="handlePasswordDialogClose">
      <el-form
        :model="passwordForm"
        :rules="passwordRules"
        ref="passwordFormRef"
        label-width="140px">
        <el-form-item label="現在のパスワード" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="現在のパスワードを入力"
            show-password />
        </el-form-item>
        <el-form-item label="新しいパスワード" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="新しいパスワードを入力（6文字以上）"
            show-password />
        </el-form-item>
        <el-form-item label="新しいパスワード（確認）" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="新しいパスワードを再入力"
            show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="passwordDialogVisible = false">キャンセル</el-button>
          <el-button type="primary" @click="handlePasswordSubmit" :loading="passwordSubmitting">
            変更
          </el-button>
        </span>
      </template>
    </el-dialog>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ROUTES, ROLE_VALUES } from '@/config/constants';
import { ElMessageBox, ElMessage } from 'element-plus';
import { HomeFilled, Box, Edit, Document, Setting, ArrowDown, User } from '@element-plus/icons-vue';
import request from '@/components/common/request';
import type { FormInstance, FormRules } from 'element-plus';

export default defineComponent({
  name: 'LayoutPage',
  components: {
    HomeFilled,
    Box,
    Edit,
    Document,
    Setting,
    ArrowDown,
    User,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    // ユーザー役割をrefで管理
    const currentUserRole = ref<string>('user');
    const permittedDeptList = ref<string[]>([]);
    const loginUserName = ref<string>('');
    const passwordDialogVisible = ref(false);
    const passwordSubmitting = ref(false);
    const passwordFormRef = ref<FormInstance>();
    const passwordForm = ref({
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    });

    const passwordRules: FormRules = {
      oldPassword: [
        { required: true, message: '現在のパスワードを入力してください', trigger: 'blur' },
      ],
      newPassword: [
        { required: true, message: '新しいパスワードを入力してください', trigger: 'blur' },
        { min: 6, message: 'パスワードは6文字以上で入力してください', trigger: 'blur' },
      ],
      confirmPassword: [
        { required: true, message: '新しいパスワード（確認）を入力してください', trigger: 'blur' },
        {
          validator: (_rule: any, value: string, callback: any) => {
            if (value !== passwordForm.value.newPassword) {
              callback(new Error('新しいパスワードが一致しません'));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
      ],
    };

    const defaultActive = computed(() => {
      return route.path.replace('/', '') || ROUTES.DASHBOARD;
    });

    // 在庫確認・申請可能数確認関連パス
    const inventoryPaths: string[] = [
      ROUTES.INVENTORY,
      ROUTES.USAGE_CONFIRMATION,
      ROUTES.DECREASE_DELETE_REQUEST,
      ROUTES.INVENTORY_HISTORY,
      ROUTES.ARRIVAL_STATUS,
    ];

    // 申請・受入関係パス
    const requestSheetPaths: string[] = [
      ROUTES.REQUEST_LIST,
      // ROUTES.REQUEST_REGISTER, // 定数master判断业务（発注確認・不足確認）入口暂时注释
      ROUTES.REQUEST_REGISTER_CONSUMPTION,
      ROUTES.DECREASE_DELETE_REQUEST_LIST,
      ROUTES.ORDER_CONFIRM_IN,
    ];

    // 発注関連パス
    const orderSheetPaths: string[] = [
      ROUTES.REQUEST_LIST_SPD,
      ROUTES.ORDER_REGISTER_OUT,
    ];

    // 设定相关路径（所有master表 + 環境設定）
    const settingPaths: string[] = [
      ROUTES.DEPARTMENT,
      ROUTES.ITEM,
      ROUTES.USER,
      // ROUTES.CONSTANT, // 定数设定（定数マスタ）入口暂时注释
      ROUTES.USAGE_LIMIT,
      ROUTES.MESSAGE,
      ROUTES.BUDGET_ADJUSTMENT,
      ROUTES.ENV_SETTINGS,
    ];

    const canBudgetAdjustment = computed(() =>
      currentUserRole.value === ROLE_VALUES.SYSTEM ||
      currentUserRole.value === ROLE_VALUES.MANAGER
    );

    const showSettingsMenu = computed(() =>
      currentUserRole.value === ROLE_VALUES.SYSTEM ||
      currentUserRole.value === ROLE_VALUES.MANAGER ||
      currentUserRole.value === ROLE_VALUES.SPD
    );

    const goToPath = (path: string) => {
      router.push(`/${path}`);
    };

    const handleChangePassword = () => {
      passwordForm.value = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      };
      passwordDialogVisible.value = true;
    };

    const handlePasswordSubmit = async () => {
      if (!passwordFormRef.value) return;

      await passwordFormRef.value.validate(async (valid: boolean) => {
        if (valid) {
          passwordSubmitting.value = true;
          try {
            const userInfoStr = localStorage.getItem('userInfo');
            if (userInfoStr) {
              const userInfo = JSON.parse(userInfoStr);
              const userId = userInfo.user_id;
              
              const response = await request.put(`/users/password/${userId}`, { 
                OldPassword: passwordForm.value.oldPassword,
                Password: passwordForm.value.newPassword,
                UserName: userInfo.user_name,
                Role: userInfo.role,
              });
              if (response.data.code === 0) {
                ElMessage.success('パスワードが正常に変更されました');
                passwordDialogVisible.value = false;
              } else {
                ElMessage.error(response.data.message || 'パスワードの変更に失敗しました');
              }
            }
          } catch (error: any) {
            const errorMessage = error.response?.data?.message || 'パスワードの変更に失敗しました';
            ElMessage.error(errorMessage);
          } finally {
            passwordSubmitting.value = false;
          }
        }
      });
    };

    const handlePasswordDialogClose = () => {
      if (passwordFormRef.value) {
        passwordFormRef.value.resetFields();
      }
    };

    const handleLogout = () => {
      ElMessageBox.confirm('ログアウトしますか？', '確認', {
        confirmButtonText: 'ログアウト',
        cancelButtonText: 'キャンセル',
        type: 'warning',
      }).then(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        router.push(`/${ROUTES.LOGIN}`);
      }).catch(() => {
        // キャンセル
      });
    };

    onMounted(() => {
      // ユーザー情報をlocalStorageから取得（ログイン時に保存済み）
      const userInfoStr = localStorage.getItem('userInfo');
      console.log('=== User Info Debug ===');
      console.log('User info from localStorage:', userInfoStr);
      
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          currentUserRole.value = userInfo.role || 'user';
          permittedDeptList.value = userInfo.permitted_dept_list || [];
          loginUserName.value = userInfo.user_name || '';
          
          // デバッグ情報
          console.log('User info loaded:', {
            role: currentUserRole.value,
            userId: userInfo.user_id,
            userName: loginUserName.value,
            deptList: userInfo.permitted_dept_list,
            isUser: currentUserRole.value === ROLE_VALUES.USER,
          });
        } catch (error) {
          console.error('Failed to parse userInfo:', error);
        }
      } else {
        console.log('No userInfo found in localStorage');
      }
      console.log('=== End User Info Debug ===');
    });

    return {
      ROUTES,
      ROLE_VALUES,
      canBudgetAdjustment,
      showSettingsMenu,
      currentUserRole,
      defaultActive,
      inventoryPaths,
      requestSheetPaths,
      orderSheetPaths,
      settingPaths,
      passwordDialogVisible,
      passwordSubmitting,
      passwordFormRef,
      passwordForm,
      passwordRules,
      goToPath,
      handleChangePassword,
      handlePasswordSubmit,
      handlePasswordDialogClose,
      handleLogout,
      loginUserName,
      HomeFilled,
      Box,
      Edit,
      Document,
      Setting,
      ArrowDown,
      User,
    };
  },
});
</script>

